import { slug } from './content/helpers';
import { z } from 'zod';

export const claimCardSchema = z.object({
  line1: z.string(),
  line2: z.string(),
  line3: z.string(),
});

export const claimLocaleSchema = z.object({
  name: z.string().max(100),
  path: slug,
  card: claimCardSchema,
  description: z.string(),
});

export const claimContentSchema = z.object({
  card: claimCardSchema,
  background_image: z.string(),
  description: z.string(),
  icon: z.string(),
});

export const claimSectionSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  claim_type_id: z.number().int().positive(),
  path: z.string().max(100).optional(),
  visible: z.boolean(),
  i18n: z.object({
    es: claimLocaleSchema,
  }),
  content: claimContentSchema,
});

export type ClaimSectionInput = z.infer<typeof claimSectionSchema>;
